export default __webpack_public_path__ + "static/media/2501253.e64d1a29.png";